<template>
  <main class="main  page-inside">
    <div class="main-wrapper">
      <section class="section hero-section sale-section product-list-section">
        <div class="wrapper">
          <router-link to="/home" class="back"><span>{{ $t(`Back to main`) }}</span></router-link>
          <div class="title">{{ $t(`Special price`) }}</div>
          <div class="list products sale-products">
            <div class="item" v-for="(item, index) in $parent.saleProducts" :key="index">
              <ProductCard :item="item" :tag="'Sale'" :addToCartChosenItem="addToCartChosenItem" :sliderIsClickble="true" @goToProduct="goToProduct" :currency="currency" @addToCart="addToCart"/>
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>
<script>
import ProductCard from '../components/ProductCard.vue'

export default {
  name: 'Sale',
  props: ['addToCartChosenItem', 'currency'],
  components: {
    ProductCard
  },
  data: function() {
    return {
      imgDomain: ''
    }
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  },
  methods: {
    addToCart(item, id, item_type) {
      this.$emit('addToCart', item, id, item_type)
    },
    goToProduct(item) {
      this.$emit('goToProduct', item)
    }
  }
}
</script>